import { createBrowserHistory } from "history" 
import { Platform } from "react-native"
export const history =  Platform.OS=="web"? createBrowserHistory():{}